"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessMemberResponseToJSON = exports.BusinessMemberResponseFromJSONTyped = exports.BusinessMemberResponseFromJSON = exports.instanceOfBusinessMemberResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessInvitationStatus_1 = require("./BusinessInvitationStatus");
var BusinessRole_1 = require("./BusinessRole");
/**
 * Check if a given object implements the BusinessMemberResponse interface.
 */
function instanceOfBusinessMemberResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBusinessMemberResponse = instanceOfBusinessMemberResponse;
function BusinessMemberResponseFromJSON(json) {
    return BusinessMemberResponseFromJSONTyped(json, false);
}
exports.BusinessMemberResponseFromJSON = BusinessMemberResponseFromJSON;
function BusinessMemberResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : (0, BusinessRole_1.BusinessRoleFromJSON)(json['role']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'emailAddress': !(0, runtime_1.exists)(json, 'email_address') ? undefined : json['email_address'],
        'memberId': !(0, runtime_1.exists)(json, 'member_id') ? undefined : json['member_id'],
        'permissionStatus': !(0, runtime_1.exists)(json, 'permission_status') ? undefined : (0, BusinessInvitationStatus_1.BusinessInvitationStatusFromJSON)(json['permission_status']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'businessId': !(0, runtime_1.exists)(json, 'business_id') ? undefined : json['business_id'],
    };
}
exports.BusinessMemberResponseFromJSONTyped = BusinessMemberResponseFromJSONTyped;
function BusinessMemberResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'role': (0, BusinessRole_1.BusinessRoleToJSON)(value.role),
        'name': value.name,
        'email_address': value.emailAddress,
        'member_id': value.memberId,
        'permission_status': (0, BusinessInvitationStatus_1.BusinessInvitationStatusToJSON)(value.permissionStatus),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'business_id': value.businessId,
    };
}
exports.BusinessMemberResponseToJSON = BusinessMemberResponseToJSON;
